import { EltType } from 'legacy/lut/classes/models/partner360/ELT/EltType'
import { IELTFinancialData } from 'legacy/lut/classes/models/partner360/ELT/IELTFinancialData'
import {
  ELT_FORM_SECTION,
  TComplexSectionData,
  TEltFormData,
} from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'
import { TForceUpdateConfig } from 'legacy/lut/components/widgets/public/partner360/ELT/models/TForceUpdateConfig'
import { formHpSobFromFinancialData } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/financialSnapshot/hpSob/helpers/formHpSobFromFinancialData'

import { formRevenueDataFromFinancialData } from '../../ui/revenue/helpers/formRevenueDataFromFinancialData'
import { separateFinancialData } from '../separateFinancialData'

import { forceUpdateCompetitors } from './forceUpdateCompetitors'
import { getLongTermPriorities } from './getLongTermPriorities'
import { getShortTermPriorities } from './getShortTermPriorities'

interface IGetComplexForceUpdateData {
  financialData: IELTFinancialData
  section: ELT_FORM_SECTION
  dataForSave: TEltFormData
  config?: TForceUpdateConfig
  markets?: string[]
  eltType: EltType
}
export const getComplexForceUpdateData = ({
  financialData,
  section,
  config,
  dataForSave,
  markets,
  eltType,
}: IGetComplexForceUpdateData): TComplexSectionData | 'NOT_FOUND' => {
  const { revenueSnapshots, competitorsSnapshots } = separateFinancialData(financialData, eltType)
  if (section === ELT_FORM_SECTION.LONG_TERM_PRIORITIES) {
    return getLongTermPriorities(financialData)
  }
  if (section === ELT_FORM_SECTION.SHORT_TERM_PRIORITIES) {
    return getShortTermPriorities(financialData)
  }

  if (section === ELT_FORM_SECTION.REVENUE && revenueSnapshots) {
    return formRevenueDataFromFinancialData(revenueSnapshots, config?.revenue, markets)
  }

  if (section === ELT_FORM_SECTION.COMPETITORS && competitorsSnapshots) {
    return forceUpdateCompetitors(competitorsSnapshots, dataForSave.CompetitiveLandscape, eltType)
  }

  if (section === ELT_FORM_SECTION.HP_SOB && financialData?.HPSob) {
    return formHpSobFromFinancialData(financialData.HPSob)
  }
  return 'NOT_FOUND'
}
